export enum JobType {
  partial = 'Partial',
  quickFix = 'Quick Fix',
  cosmetic = 'Cosmetic',
  asIs = 'As Is'
}
